import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsUploadAreaComponent } from "./ds-upload-area.component";
import { MatIconModule } from "@angular/material/icon";
import { DsButtonModule } from "../ds-button/ds-button.module";
import { DsLoaderModule } from "../ds-loader/ds-loader.module";
import { DsTooltipDirective } from "../directive/ds-tooltip.directive";
import { LayoutModule } from "@angular/cdk/layout";
import { DsNotificationModule } from "../ds-notification/ds-notification.module";
import { DsIconModule } from "../ds-icon/ds-icon.module";

@NgModule({
  declarations: [DsUploadAreaComponent],
  imports: [
    CommonModule,
    MatIconModule,
    DsButtonModule,
    DsLoaderModule,
    DsTooltipDirective,
    LayoutModule,
    DsNotificationModule,
    DsIconModule,
  ],
  exports: [DsUploadAreaComponent],
})
export class DsUploadAreaModule {}
